export default "__VITE_ASSET__CtMNdd4z__"